


























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Cart } from '@/interfaces/cart';

@Component
export default class CartFormInput extends Vue {
  private data: string | null = null;
  private disabled: boolean = true;
  private items: any = [];

  @Prop({ type: Object, required: true }) action!: Cart.Action;

  get itemValue() {
    if (this.action.selectable && this.action.selection!.key) {
      return this.action.selection!.key;
    }
    return '_id';
  }

  get itemText() {
    if (this.action.selectable && this.action.selection!.text) {
      return this.action.selection!.text;
    }
    return 'name';
  }

  async mounted() {
    this.items = [];
    if (this.action.selectable) {
      this.items = await this.action.getSelectableItems!();
    }
  }

  @Watch('data')
  onDataChange(newData: string) {
    this.disabled = !newData;
  }

  onSave() {
    this.$emit('data', { action: this.action, data: this.data });
  }
}
